export default __webpack_public_path__ + "static/media/restartAlt.b4f566f9.svg";